import { render, staticRenderFns } from "./DoctorSettingContainer.vue?vue&type=template&id=7b4f0ece&scoped=true"
import script from "./DoctorSettingContainer.vue?vue&type=script&lang=js"
export * from "./DoctorSettingContainer.vue?vue&type=script&lang=js"
import style0 from "./DoctorSettingContainer.vue?vue&type=style&index=0&id=7b4f0ece&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4f0ece",
  null
  
)

export default component.exports